import { css } from '@emotion/react'

const border = {
   left: css`
      box-sizing: content-box;
      border-left-width: 1px;
      border-left-style: solid;
      border-image: linear-gradient(
         to bottom,
         rgba(115, 115, 115, 0.05) 0%,
         #e1e1e1 50%,
         rgba(115, 115, 115, 0.05) 100%
      );
      border-image-slice: 1;
   `,
   right: css`
      box-sizing: content-box;
      border-right-width: 1px;
      border-right-style: solid;
      border-image: linear-gradient(
         to bottom,
         rgba(115, 115, 115, 0.05) 0%,
         #e1e1e1 50%,
         rgba(115, 115, 115, 0.05) 100%
      );
      border-image-slice: 1;
   `,
   top: css`
      box-sizing: content-box;
      border-top-width: 1px;
      border-top-style: solid;
      border-image: linear-gradient(
         to right,
         rgba(115, 115, 115, 0.05) 0%,
         #e1e1e1 50%,
         rgba(115, 115, 115, 0.05) 100%
      );
      border-image-slice: 1;
   `,
   bottom: css`
      box-sizing: content-box;
      border-bottom-width: 1px;
      border-bottom-style: solid;
      border-image: linear-gradient(
         to right,
         rgba(115, 115, 115, 0.05) 0%,
         #e1e1e1 50%,
         rgba(115, 115, 115, 0.05) 100%
      );
      border-image-slice: 1;
   `,
}

const shadow = {}

const svg = {}

const scrollBar = css`
   ::-webkit-scrollbar {
      width: 9px;
      border-radius: 28px;
      overflow: hidden;
   }
   ::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 28px;
   }
   ::-webkit-scrollbar-thumb {
      background: #888;
      border-radius: 28px;

      &:hover {
         background: #555;
      }
   }
`

const gradient = {}

export { border, shadow, svg, scrollBar, gradient }
